/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'calculator': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<mask id="svgicon_calculator_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="2" width="16" height="20"><path pid="0" d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 2h12v2H6V4zm0 4h12v12H6V8zm2 2v2h2v-2H8zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm-6 3v2h2v-2H8zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm-6 3v2h2v-2H8zm3 0v2h5v-2h-5z" _fill="#fff"/></mask><g mask="url(#svgicon_calculator_a)"><path pid="1" d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 2h12v2H6V4zm0 4h12v12H6V8zm2 2v2h2v-2H8zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm-6 3v2h2v-2H8zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm-6 3v2h2v-2H8zm3 0v2h5v-2h-5z" _fill="#22262A"/></g>'
  }
})
